/**
 * GlassChipSelector — Manages the glass type chip selector in the center column.
 *
 * Handles click events on glass chips to highlight the active glass type
 * and coordinate with the navbar glass pills.
 */
export default class GlassChipSelector {
  constructor() {
    this.chips = document.querySelectorAll('.glass-chip');
    this.pills = document.querySelectorAll('.glass-pill');
    this.activeGlass = 'frg';

    this._initChips();
    this._initPills();
  }

  _initChips() {
    this.chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const glass = chip.dataset.glass;
        this._setActive(glass);
      });
    });
  }

  _initPills() {
    this.pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const glass = pill.dataset.glass;
        this._setActive(glass);
      });
    });
  }

  _setActive(glass) {
    this.activeGlass = glass;

    // Update chips
    this.chips.forEach(chip => {
      chip.classList.toggle('active', chip.dataset.glass === glass);
    });

    // Update pills
    this.pills.forEach(pill => {
      pill.classList.toggle('active', pill.dataset.glass === glass);
    });
  }
}
